import React from 'react';
export function OpeningHook() {
  return <section className="py-24 px-4 bg-warm-light" data-id="element-124">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center" data-id="element-125">
        <div className="relative order-2 lg:order-1" data-id="element-126">
          <img src="https://cdn.magicpatterns.com/uploads/potGD4U8Wmtt4popkZVXLL/nRYVOVUPqj8nQouYOImR7.png" alt="Niña en el campo de fútbol" className="w-full h-auto object-cover rounded-sm" data-id="element-127" />
        </div>

        <div className="order-1 lg:order-2 space-y-8" data-id="element-128">
          <div className="space-y-6 text-lg text-warm-mid leading-relaxed" data-id="element-129">
            <p data-id="element-130">
              <strong className="text-warm-dark font-semibold" data-id="element-131">
                Sabes exactamente cuándo ocurre.
              </strong>{' '}
              Ves a tu hijo o hija cometer un error en el campo y, en un
              instante, su lenguaje corporal cambia. Los hombros caen, la mirada
              se pierde y sabes que, para ellos, el partido terminó mucho antes
              del silbatazo final.
            </p>

            <p data-id="element-132">
              El viaje de regreso a casa en el auto se convierte en un silencio
              asfixiante. Quieres ayudar, pero cada palabra que dices parece
              empeorar las cosas.
            </p>
          </div>

          <div className="border-t border-warm-dark/15 pt-8" data-id="element-133">
            <p className="text-2xl md:text-3xl font-heading text-warm-dark" data-id="element-134">
              No es falta de talento; es una mente bajo demasiada presión.
            </p>
          </div>
        </div>
      </div>
    </section>;
}